var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailLogoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 4.66675L6.77531 8.47704C7.21609 8.78559 7.43648 8.93986 7.67621 8.99962C7.88796 9.0524 8.10943 9.0524 8.32119 8.99962C8.56091 8.93986 8.7813 8.78559 9.22208 8.47704L14.6654 4.66675M4.53203 13.3334H11.4654C12.5855 13.3334 13.1455 13.3334 13.5733 13.1154C13.9497 12.9237 14.2556 12.6177 14.4474 12.2414C14.6654 11.8136 14.6654 11.2535 14.6654 10.1334V5.86675C14.6654 4.74664 14.6654 4.18659 14.4474 3.75877C14.2556 3.38244 13.9497 3.07648 13.5733 2.88473C13.1455 2.66675 12.5855 2.66675 11.4654 2.66675H4.53203C3.41193 2.66675 2.85187 2.66675 2.42405 2.88473C2.04773 3.07648 1.74176 3.38244 1.55002 3.75877C1.33203 4.18659 1.33203 4.74664 1.33203 5.86675V10.1334C1.33203 11.2535 1.33203 11.8136 1.55002 12.2414C1.74176 12.6177 2.04773 12.9237 2.42405 13.1154C2.85187 13.3334 3.41193 13.3334 4.53203 13.3334Z",
    stroke: "#A39992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogoOff);
export default __webpack_public_path__ + "static/media/Mail-logo-off.dbb2f7a9fc1a240ae353a5a8a602045a.svg";
export { ForwardRef as ReactComponent };